import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 0;

    & > div:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    color: var(--gray800);
    fill: var(--gray800);
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.16px;
    font-weight: 600;
    margin-bottom: 8px;
    text-transform: uppercase;

    & > svg {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
`;

export const Title = styled.span``;

const Body = styled.div`
    padding-left: 24px;

    & > div:not(:first-child) {
        margin-top: 8px;
    }
`;

export const SectionRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    & > *:not(:last-child) {
        margin-right: 4px;
    }
`;

export const Text = styled.p`
    margin: 0;
    font-size: 14px;
    letter-spacing: 0.16px;
    line-height: 20px;
    color: var(--gray800);
`;

export const BreakText = styled.span`
    white-space: pre-line;
`;

export const TextBold = styled.span`
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.32px;
`;

export const Link = styled.a`
    display: block;
    text-decoration: none;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.16px;
    font-weight: 600;
    color: var(--blue500);
    outline: none;

    ${(props) =>
        props.disabled &&
        css`
            color: ${(props) => props.theme.colors['surface-grey-700']};
            cursor: initial;
            pointer-events: none;
        `}

    &:focus,
    &:focus-visible {
        box-shadow: var(--outline);
    }

    &:focus:not(:focus-visible) {
        box-shadow: none;
    }
`;

const Section = ({ title, Icon, children }) => {
    return (
        <Container>
            <TitleContainer>
                {Icon && <Icon />}
                <Title>{title}</Title>
            </TitleContainer>
            <Body>{children}</Body>
        </Container>
    );
};

Section.propTypes = {
    title: PropTypes.string,
    Icon: PropTypes.node,
    children: PropTypes.node,
};

export default Section;
